import {initializeApp, getApps, getApp} from 'firebase/app';

// Öffentliche Web-Konfiguration des Firebase-Projekts. Diese Werte sind kein
// Geheimnis; der Zugriffsschutz erfolgt über die Firestore-Regeln
// (siehe firestore.rules im Projektstamm).
const firebaseConfig = {
  apiKey: 'AIzaSyCKjqyEpdXcbfbJCx1PL5qbR879I9Nv3EA',
  authDomain: 'cura-care-6068b.firebaseapp.com',
  projectId: 'cura-care-6068b',
  storageBucket: 'cura-care-6068b.firebasestorage.app',
  messagingSenderId: '233251220255',
  appId: '1:233251220255:web:8bd88fcc086b67c1861e2a',
  measurementId: 'G-FY3YYKS8N0'
};

/** Initialisiert die Firebase-App erst beim ersten Zugriff (kein Netzwerk beim Seitenaufruf). */
export const getFirebaseApp = () => (getApps().length ? getApp() : initializeApp(firebaseConfig));

/**
 * Schickt eine Kontaktanfrage an die Cloud Function "submitContact". Sie prüft
 * Spam-Schutz und Limits und legt die Anfrage in Firestore an; direktes
 * Schreiben aus dem Browser ist gesperrt. Bewusst direkt und nicht über einen
 * Hosting-Rewrite, damit die Funktion die echte Absender-IP sieht.
 * Wirft einen Fehler mit `status` (z. B. 429 bei zu vielen Anfragen).
 */
const CONTACT_ENDPOINT = 'https://europe-west3-cura-care-6068b.cloudfunctions.net/submitContact';

export async function submitContactMessage(data) {
  const res = await fetch(CONTACT_ENDPOINT, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(data)
  });
  if (!res.ok) {
    const error = new Error(`Kontaktanfrage fehlgeschlagen (${res.status})`);
    error.status = res.status;
    throw error;
  }
  return res.json();
}
